import Service, { inject as service } from '@ember/service';

export default class LegalCommands extends Service {
  @service api;
  @service shData;
  @service store;

  /**
   *
   * @param {Array} types
   * @param {Number} page
   * @param {Number} count
   * @param {String} cache_key
   * @returns {Promise}
   */
  loadLegals(types = [], page, count) {
    const options = {
      params: {
        page,
        count,
        filter: { types },
      }
    };

    return this.api.request('/admin/legals', options);
  }

  /**
   *
   * @param {String} title
   * @param {String} content
   * @returns {Promise}
   */
  createLegal(type, title, content) {
    const options = {
      jsonData: {
        type,
        title,
        content
      }
    };

    return this.api.post('/admin/legals', options);
  }
}
